<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Rejestracje'" [parentName]="'Identyfikatory'" [name]="'Lista'"></app-breadcrumb>
<div class="identifier-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="identifier-list-filters">
    <ng-container *ngIf="!disableFilters">
      <app-dict-ofwcas
        *ngIf="ofwcaId === null" [multiple]="false"
        label="OFWCA" class="identifier-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-insurance-companies
        (selectedInsuranceCompanies)="insuranceCompanyFilterChanged($event)"
        *ngIf="insuranceCompanyId === null" [multiple]="true"
        label="TU" class="identifier-list-filter"
        [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="true" label="Status"
        class="identifier-list-filter"
        dictType="registration_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <app-dict
        [onlyKeys]="typeOnlyKeys" [multiple]="true"
        label="Rodzaj" class="identifier-list-filter"
        dictType="registration_id_type"
        [(ngModel)]="initialFilters.in$type" name="in$type"
      ></app-dict>

      <mat-form-field class="identifier-list-filter">
        <mat-label>Identyfikator</mat-label>
        <input matInput placeholder="12345"
               name="contains$value" [(ngModel)]="initialFilters.contains$value"
        >
      </mat-form-field>

      <app-dict-partners
        *ngIf="ofwcaId === null"
        [multiple]="false" label="Partner"
        class="identifier-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict-regionals
        *ngIf="ofwcaId === null"
        [multiple]="true" label="Regionalny (majątek)"
        class="identifier-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <mat-form-field appearance="standard" class="identifier-list-filter" *ngIf="ofwcaId === null">
        <mat-label>Identyfikatory wartość</mat-label>
        <mat-select [(ngModel)]="initialFilters.valueIdentifiers" name="valueIdentifiers">
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <app-dict
        [multiple]="false"
        label="Firma" class="identifier-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>

      <app-dict-partners
        [multiple]="false" label="Partner nadrzędny"
        class="identifier-list-filter"
        [(ngModel)]="initialFilters.parentPartner" name="parentPartner"
      ></app-dict-partners>

    </ng-container>
  </form>

  <div class="identifier-list-buttons" *ngIf="!disableFilters">
    <button *ngIf="(userPermissions | async).registration_additional.read_report" [disabled]="!(userPermissions | async).registration_additional?.read_report"
            mat-raised-button [matMenuTriggerFor]="generateRegional" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generateRegional="matMenu">
      <button *ngIf="(userPermissions | async).registration_additional.read_report" [disabled]="!(userPermissions | async).registration_additional?.read_report"  mat-menu-item (click)="downloadReportRegional()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).registration_additional.read_report" [disabled]="!(userPermissions | async).registration_additional?.read_report" mat-menu-item (click)="openReportDialogRegional()">Pobierz raport niestandardowy</button>
    </mat-menu>

    <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report"
            mat-raised-button [matMenuTriggerFor]="generate" class="report-button">
      <mat-icon>download</mat-icon> Pobierz raport</button>
    <mat-menu #generate="matMenu">
      <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report"  mat-menu-item (click)="downloadReport()">Pobierz raport pełny</button>
      <button *ngIf="(userPermissions | async).registration.read_report" [disabled]="!(userPermissions | async).registration.read_report" mat-menu-item (click)="openReportDialog()">Pobierz raport niestandardowy</button>
    </mat-menu>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="identifiers">

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.registration.ofwca.uuid]">
          {{element.registration.ofwca.fullName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/tu/szczegoly', element.registration.insuranceCompany.id]">
          {{element.registration.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="registration">
      <th mat-header-cell *matHeaderCellDef> Rejestracja </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.registration.uuid]">
          {{element.registration.insuranceCompany.name}} {{element.registration.ofwca.fullName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status rejestracji </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.registration.status.color + '-button'">
          {{element.registration.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
      <td mat-cell *matCellDef="let element">
        {{element.type.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef> Identyfikator </th>
      <td mat-cell *matCellDef="let element">

        <mat-chip-list *ngIf="element.type.valueType === 'string' && element.value">
          <ng-container *ngFor="let value of element.value.split(', '); let last = last">
            <mat-chip *ngIf="value && last" color="accent" selected matTooltip="{{value}}" (click)="copyMessage(value)">
              {{(value.length>35) ? (value | slice:0:35)+'...':(value)}}</mat-chip>
            <mat-chip *ngIf="value && !last && element.type.key !=='manager'
                          && element.type.key !=='manager_email'
                          && element.type.key !=='manager_phone'
                          && element.type.key !=='generali_agro_ic_email'
                          && element.type.key !=='generali_agro_ic_manager'
                          && element.type.key !=='generali_agro_ic_phone' " (click)="copyMessage(value)"
                      matTooltip="{{value}}"
            >{{(value.length>35) ? (value | slice:0:35)+'...':(value)}}</mat-chip>

          </ng-container>
        </mat-chip-list>
        <ng-container *ngIf="element.type.valueType !== 'string'">
          <app-detail-bool [value]="element.value.toLowerCase() === 'tak'"></app-detail-bool>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
<!--      <th mat-header-cell *matHeaderCellDef></th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>-->
<!--        <mat-menu #menu="matMenu" xPosition="before">-->
<!--          <button [disabled]="!(userPermissions | async).registration.delete" mat-menu-item (click)="delete(element)">Usuń</button>-->
<!--        </mat-menu>-->
<!--      </td>-->
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
